import { AppData, Img, Lightning, Log, Registry, Router, Utils } from '@lightningjs/sdk'
import VideoResumeBar from './video-resume-bar'
import { Theme } from './info-ui'
import { AppSetup } from '../lib/app-setup'
import { Icon } from '@lightningjs/ui-components'
import { Helper } from '../lib/helper'

export interface ThumbItemTemplateSpec extends Lightning.Component.TemplateSpecLoose{
  ImageWrapper: object
  Image: object
  Fill: object
  imgTexture: any
}

export default class ThumbItem
  extends Lightning.Component<ThumbItemTemplateSpec>
  implements Lightning.Component<ThumbItemTemplateSpec>
{
  _theme: Theme = {};
  ImageWrapper = this.getByRef('ImageWrapper')!
  Image = this.getByRef('Image')!
  Fill = this.getByRef('Fill')!
  _imgTexture:any
  enterPressTime = new Date().getTime()
  isEnterPress = false;
  private _focusAnimation: Lightning.types.Animation | undefined = this.animation({
    duration: 0.4,
    actions: [
      { p: 'scale', v: { 0: 1, 1: 1.1 } },
      { t: 'Focus', p: 'alpha', v: { 0: 0, 1: 1 } },
    ],
  });

  static override _template(): Lightning.Component.Template<ThumbItemTemplateSpec> {
    return {
      collision:true,
      ImageWrapper: {
        x: 0,
        y: 0,
        w: (w) => w,
        h: (h) => h,
        rect: true,
        color: 0xff222222,
        Image: {},
        VideoResumeBar: {
          x: 0,
          y: (h) => h - VIDEO_RESUME_BAR_HEIGHT,
          h: VIDEO_RESUME_BAR_HEIGHT,
          type: VideoResumeBar,
          item: this.bindProp("item"),
          zIndex: 1,
        },
        BlockItem : {
            w: (w) => w,
            h: (h) => h,
            rect:true,
            color: 0xAA222222,
            Icon: {
                mountX:1,
                type: Icon,
                x: (w) => w - 10,
                y: 10,
                w:50,
                h:50,
                icon: Utils.asset('/svg/ico-block.svg'),
            },
            zIndex: 3,
            visible:false,
            shader: {}
        },
        Focus: {
          x: (w) => w / 2,
          y: (h) => h / 2,
          w: (w) => w,
          h: (h) => h,
          alpha: 0,
          mount: 0.5,
          rect: true,
          color: 0x00000000,
          zIndex: 4,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: 0,
            stroke: 6,
            strokeColor: 0xffffffff,
          }
        },
        ItemTitle: {
          w: (w) => w-20,
          h: (h) => h-20,
          zIndex: 2,
          flex: {
            direction: "row",
            padding: 10,
            alignItems: "flex-end"
          },
          Grad: {
            y: (h) => h/2,
            w: (w) => w,
            h: (h) => h/2,
            flexItem:false,
            rect: true,
            colorTop: 0x00000000,
            colorBottom: 0xff000000,
          },
          Text: {
            text: {
              text: "",
              fontSize: 25,
              fontFace: Helper.getFontFamily('Regular'),
              textOverflow: "ellipsis",
              shadow:true,
              shadowBlur: 5,
              wordWrap:true,
              maxLines: 3,
              maxLinesSuffix: '...'
            },
          },
          //shader: {type: Lightning.shaders.Outline, stroke: 1, color: 0x00ffffff},
          visible: false
        },
      },
    }
  }

  set imgTexture(_imgTexture) {
    this._imgTexture = _imgTexture
    this.patch({
      ImageWrapper: {
        Image: {
          //texture: Img(this.imgTexture.img).cover(this.imgTexture.w, this.imgTexture.h),
          x: this._imgTexture.w / 2,
          y: this._imgTexture.h / 2,
          alpha: 0.001,
          mount: 0.5,
          zIndex: this.core.findZContext().zIndex + 1,
          texture: {
            src: this._imgTexture.img,
            resizeMode: {
              h: this._imgTexture.h,
              type: 'cover',
              w: this._imgTexture.w
            },
            type: Lightning.textures.ImageTexture
          },
        }
      }
    })
    // this.patch({
    //   ImageWrapper: {
    //     Image: {
    //       texture: Img(imgTexture.img).cover(imgTexture.w, imgTexture.h),
    //     }
    //   }
    // })
    // this.patch({
    //   ItemTitle: {
    //     zIndex: this.core.findZContext().zIndex + 1,
    // }});
  }


  override _init() {
    const image = this.tag('Image')

    const { appState } = AppData as AppSetup
    const app = appState?.getApp();
    this._theme = (app?.themesObj as Theme) || {};
    const appApiConfig = appState?.getAppApiConfig()
    this._theme.gridfocuscolor= `0xff${appApiConfig?.appLayoutConfig?.gridfocuscolor}` || '0xffffffff'

    image?.on('txLoaded', () => {
      image.setSmooth('alpha', 1)
    })
    let activeRoute = Router.getActiveRoute();
    if (activeRoute && activeRoute.indexOf('search-screen') > -1) {
      this.tag("ItemTitle").visible = true;
    }
    if(this.item.blockItem) {
        this.tag('BlockItem').visible = true;
    }
    if(this.item && this.item.title){
      let _title = this.item?.title;
      if(_title.length > 30) {
        _title = _title.substring(0, 30) + '...';
      }
      this.patch({
        ImageWrapper: {
          ItemTitle: {
            Text: {
              text:{ 
                wordWrapWidth: this._imgTexture.w-20,
                text:_title
              }
            }

          }
      }});
    }

  }

  override _focus() {
    const { platform } = AppData as AppSetup
    platform?.textToSpeach(this.item.title)

    if (this._focusAnimation) {
      this._focusAnimation.start()
    }
    this._focusAnimation?.on('progress', () => {
      this.patch({
        ImageWrapper: {
          VideoResumeBar: {
            y: this.renderHeight - VIDEO_RESUME_BAR_HEIGHT - 4
          },
          Focus: {
            shader: {
              type: Lightning.shaders.RoundedRectangle,
              radius: 0,
              stroke: 6,
              strokeColor: this._theme.gridfocuscolor,
            }
          },
        }
      });
    })

    //this.tag("ImageWrapper.VideoResumeBar").setSmooth("y",this.renderHeight-VIDEO_RESUME_BAR_HEIGHT-8)
    this.fireAncestors('$onThumbFocused', this.item?.title || '')
  }

  override _handleEnter(e: KeyboardEvent): boolean | void {
    this.fireAncestors('$handleEnter')
  }

  override _unfocus() {
    this._focusAnimation?.stop()
    //this.tag("ImageWrapper.VideoResumeBar").setSmooth("y",this.renderHeight-VIDEO_RESUME_BAR_HEIGHT)
    this.patch({
      ImageWrapper: {
        VideoResumeBar: {
          y: this.renderHeight - VIDEO_RESUME_BAR_HEIGHT
        }
      }
    });
    this.fireAncestors('$onThumbFocused',  'Top Searches')
  }

  static get width() {
    return 400
  }

  static get height() {
    return 600
  }

  _handleHover(target) {
   // console.log('RowColumnGrid _handleHover:', target)
    this.fireAncestors('$setStateHover', 'SearchListThumbItem')
    target._focus()
  }

  _handleUnhover(target) {
   // console.log('RowColumnGrid _handleUnhover:', target.ref)
    target._unfocus()
  }

}
const VIDEO_RESUME_BAR_HEIGHT = 12;
